<script>
export default {
  name: 'SpeisekarteRedirect',

  created () {
    this.$router.push({ name: 'Shop', params: { hostUrl: window.hostUrl } })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/menu/redirect.vue